import { graphql } from "@/lib/gql/__generated__";

export const RESERVATION_DETAIL_UPDATE_REFUND_REQUEST_FOR_MANAGEMENT_RESERVATION_ITEM_DETAIL_UPDATE_MUTATION = graphql(
	/* GraphQL */ `
		mutation ReservationDetailUpdateRefundRequestForManagementReservationItemDetailUpdate(
			$input: ReservationRefundRequestInput!
		) {
			reservationDetailRefundRequest(input: $input) {
				reservationDetail {
					canRefund
					canUpdate
					statusRefund
					refundedPriceByAdmin
				}
				userErrors
			}
		}
	`,
);
